import React from 'react'
import ReactMarkdown from 'react-markdown'
import classNames from 'classnames'
import styles from './TimelineItem.module.scss'

const TimelineItem = ({ date, text, image, rightSide }) => (
  <div className={styles.container}>
    <div
      className={classNames(
        rightSide ? styles.rightSide : styles.leftSide,
        styles.dateCircle
      )}
    >
      <i
        className={classNames(
          'fas',
          rightSide ? 'fa-chevron-right' : 'fa-chevron-left',
          styles.arrow
        )}
      />
      <h3 className={styles.title}>{date}</h3>
      {!!text && <ReactMarkdown linkTarget="_blank">{text}</ReactMarkdown>}
      {!!image && <img src={image} alt={date} className={styles.image} />}
    </div>
  </div>
)

export default TimelineItem
